import { getFileContentType } from "./fileUtils";
import { prepareUploadBody } from "./prepareUploadBody";

export const prepareUploadFormData = async (formData: FormData) => {
  const prepared = new FormData();
  for (const [key, value] of Array.from(formData.entries())) {
    if (value instanceof File) {
      const body = await prepareUploadBody(value, getFileContentType(value));
      // Passing the original filename prevents FormData naming the Blob "blob".
      prepared.append(key, body, value.name);
    } else {
      prepared.append(key, value);
    }
  }
  return prepared;
};
